import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import store from '../store/store'
import { setOpen, setJson, setSelectedId } from '../store/lookSlice.js'
import Container from "./Container.jsx"

const rootAttribute = 'data-look-wrap'
const jsonAttribute = 'data-look-wrap-json'
const setPreselect = (looks) => {
  const paths = location.pathname.replace(Shopify.routes.root, '').split('/')
  const id = parseInt(new URL(location.href).searchParams?.get('look'))
  let selectedJson = paths.length < 3 ? null : looks.filter(look => {
    return look.subpath == paths[2]
  })[0]
  store.dispatch(setSelectedId(isNaN(id) ? 1 : id))
  if(paths.length == 2 || !selectedJson) {
    selectedJson = looks[0]
  } else if(!!selectedJson) {
    store.dispatch(setOpen(!isNaN(id)))
  }
  if(looks.length > 0) {
    store.dispatch(setJson(selectedJson))
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const lookWrap = document.querySelector(`[${rootAttribute}]`)
  if(lookWrap) {
    const lookWraplRoot = createRoot(lookWrap)
    const looks = JSON.parse(document.querySelector(`[${jsonAttribute}]`).innerHTML)

    setPreselect(looks)

    lookWraplRoot.render(
      <Provider store={store}>
        <Container data={looks} />
      </Provider>)
    
    window.addEventListener("popstate", (event) => {
      setPreselect(looks)
    })
  }
})